/**
 * 生成 RFC 4122 版本 4 UUID（8-4-4-4-12，共 122 位随机信息）。
 * 使用加密安全随机源，碰撞概率可忽略；无法在数学上绝对“零重复”，工程上视为唯一。
 */
export const generateUuid = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.getRandomValues === "function"
  ) {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);
    buf[6] = (buf[6] & 0x0f) | 0x40;
    buf[8] = (buf[8] & 0x3f) | 0x80;
    const h = (i) => buf[i].toString(16).padStart(2, "0");
    return `${h(0)}${h(1)}${h(2)}${h(3)}-${h(4)}${h(5)}-${h(6)}${h(7)}-${h(
      8
    )}${h(9)}-${h(10)}${h(11)}${h(12)}${h(13)}${h(14)}${h(15)}`;
  }
  const hex = (len) => {
    let s = "";
    while (s.length < len) s += Math.random().toString(16).slice(2);
    return s.slice(0, len);
  };
  return `${hex(8)}-${hex(4)}-${hex(4)}-${hex(4)}-${hex(12)}`;
};
